import React from 'react';

import api     from '../../../../../api';
import values  from '../../../../../values';
import Context from '../../../../../context';

import AreaScreen from '..';

import { TModal                   } from '../../../../../types/common.type';
import { locationNamespace        } from '../../../../../types/location.namespace';
import { useQuery, UseQueryResult } from 'react-query';
import successHandler from "../../../../../utils/successHandler";

const CityContainer: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const [showModal, setShowModal] = React.useState<TModal>('NONE');
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [selectedArea, setSelectedArea] = React.useState<locationNamespace.area.index | undefined>(undefined);
  const [requestArea , setRequestArea ] = React.useState<locationNamespace.area.request>({
    limit: 10,
    page : 1 ,
  });

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------------ Start Call API -------------------------------------------------

  const getCities: UseQueryResult<any, unknown> = useQuery(
    [values.useQueryKeys.locationGetArea, requestArea],
    () => api.get.common.searchArea(requestArea)
  );

  // ! ------------------------------------------------- End Call API --------------------------------------------------
  // ! =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  async function createFunction(event: locationNamespace.area.create): Promise<void> {
    setIsLoading(true);
    const result = await api.post.administrator.createArea(event);
    successHandler(result?.CODE);
    await getCities.refetch();
    setShowModal('NONE');
    setIsLoading(false);
  }

  async function updateFunction(event: locationNamespace.area.update): Promise<void> {
    setIsLoading(true);
    if (!selectedArea) return;
    const result = await api.patch.administrator.updateArea(selectedArea?._id, event);
    successHandler(result?.CODE);
    await getCities.refetch();
    setShowModal('NONE');
    setIsLoading(false);
  }

  async function deleteFunction(): Promise<void> {
    setIsLoading(true);
    if (!selectedArea) return;
    const result = await api.dele.administrator.deleteArea(selectedArea?._id);
    successHandler(result?.CODE);
    await getCities.refetch();
    setShowModal('NONE');
    setIsLoading(false);
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <Context.Location.Area.Provider value={{
      showModal   ,
      isLoading   ,
      requestArea ,
      selectedArea,
      setShowModal   ,
      createFunction ,
      updateFunction ,
      deleteFunction ,
      setRequestArea ,
      setSelectedArea,
    }}>
      <AreaScreen rqData={getCities} />
    </Context.Location.Area.Provider>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default CityContainer;
